import { calculateConsolidationPercent } from 'utils/consolidationPeriods';
import { getVestedUnits } from 'utils/filters';
import { Beneficiary, StockPlan } from 'types';

export const getMonthsDiff = (d1: Date, d2: Date): number => {
  let months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
};

export const getConsolidationDate = (
  beneficiary: Beneficiary,
  planId: string,
  plans: StockPlan[]
): Date => {
  const plan = plans?.find((plan) => plan['_id'] === planId);
  const endDate = new Date(beneficiary?.planStartDate);

  if (plan?.vestingPeriod) {
    endDate.setMonth(endDate.getMonth() + Number(plan?.vestingPeriod));
  }
  return endDate;
};

export const getConsolidatedPercent = (
  beneficiary: Beneficiary,
  planId: string,
  plans: StockPlan[],
  date = Date.now()
): number => {
  let percent: number;
  const plan = plans?.find((plan) => plan['_id'] === planId);

  if (beneficiary?.isCanceled)
    percent = Number(
      (
        (beneficiary.finalConsolidatedUnits! * 100) /
        beneficiary.sharesCount!.future
      ).toFixed(2)
    );
  else percent = calculateConsolidationPercent(date, beneficiary, plan) || 0;

  return percent;
};

export const getToVest = (
  beneficiary: Beneficiary,
  plan: StockPlan,
  date = Date.now()
): number => {
  let toVest: number;
  if (beneficiary?.isCanceled) {
    toVest = 0;
  } else {
    const vested = getVestedUnits(beneficiary, plan, date);
    toVest = (beneficiary?.sharesCount?.future || 0) - (vested || 0);
  }
  return toVest;
};

export const getMonthsToVest = (
  beneficiary: Beneficiary,
  planId: string,
  plans: StockPlan[],
  date = Date.now()
): number => {
  const finalDate = getConsolidationDate(beneficiary, planId, plans);
  const current = date;
  if (beneficiary?.isCanceled || new Date(finalDate) < new Date(current)) {
    return 0;
  }
  const months = getMonthsDiff(new Date(current), new Date(finalDate));
  return months;
};

export const getStrikePrice = (
  beneficiary: Beneficiary,
  planId: string,
  plans: StockPlan[]
): string | number | undefined => {
  const conditions = beneficiary?.customConditions;
  if (conditions && conditions?.sharePrice) {
    return conditions?.isFixedPrice
      ? `${conditions?.sharePrice} (fijo)`
      : conditions?.sharePrice;
  }
  const plan = plans?.find((plan) => plan['_id'] === planId);
  return plan?.isFixedPrice ? `${plan?.sharePrice} (fijo)` : plan?.sharePrice;
};
